import {TextField} from "helpers/forms/fields/TextField";
import {FormattedMessage} from "react-intl";

/**
 * Represents an email input field component.
 *
 * @param {Object} props - The properties passed to the component.
 * @returns {JSX.Element} - The email input field.
 */
export const EMailField = (props) => (
  <TextField
    label={<FormattedMessage id="field.email.label" defaultMessage="Email address"/>}
    type="email"
    {...props}
  />
);
